import type { CellProps } from '../../interfaces'
import type { FC } from 'react'

import styled from 'styled-components'

import CheckRegister from '../../API/checkRegister'
interface Props extends CellProps {
  href?: string
  s3Key?: string
  entId?: string
  groupNumber?: string
}

const ButtonGridDownload = styled.a`
  background: #edf0f1;
  border-radius: 4px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.3px;
  width: 100px;
  height: 24px;
  color: #0076e3;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`
const ButtonGridStyled: FC<Props> = ({ href: _href, s3Key, entId, groupNumber }) => {
  const click = () => {
    if (s3Key && entId && groupNumber) {
      CheckRegister.getCheckRegisterDownload({
        fileKey: s3Key,
        entId,
        groupNumber
      }).then(response => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(
          new Blob([response.file], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'
          })
        )
        link.download = response.name
        link.click()
      })
    }
  }
  return (
    <div className='custom-cell custom-cell__button'>
      <ButtonGridDownload
        onClick={click}
        // href={`http://dev-payments.lucenthealth.com/api/checkRegister/getReport?fileKey=${s3Key}`}
        download
        target='_blank'
      >
        Download
      </ButtonGridDownload>
    </div>
  )
}

export default ButtonGridStyled
